module.exports = __webpack_public_path__ + "img/AE.2ac1a44d.svg";